<lcs-loading-overlay
   class="flex-dir-col"
   [show]="callState | lcsCallState : 'loading'"
   *ndtErrorPage="!(callState | lcsCallState : 'error'); entityName: 'User Preferences'"
>
   <div class="detail-page-headerbar">
      <div class="left">
         <div class="page-heading">
            <h2 class="page-title">Preferences - {{ user?.name }}</h2>
         </div>
      </div>
      <div class="right context-actions">
         <button
            type="button"
            mat-button
            [matMenuTriggerFor]="updateDetailsMenu"
            matTooltip="Info"
            aria-label="User Info"
            id="user-info"
         >
            <mat-icon>info</mat-icon>
         </button>
      </div>
   </div>
   <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <ndt-two-column-layout>
         <div ndtLeftColumn>
            <div class="details-wrapper">
               <ng-container>
                  <h5>Username</h5>
                  <div class="detail-item">{{ user?.username ? user?.username : 'N/A' }}</div>
               </ng-container>
               <ng-container>
                  <h5>Email Address</h5>
                  <div class="detail-item">{{ user?.emailAddress ? user?.emailAddress : 'N/A' }}</div>
               </ng-container>
               <ng-container>
                  <h5>Account</h5>
                  <div class="detail-item">{{ user?.account?.name ? user?.account?.name : 'N/A' }}</div>
               </ng-container>
               <ng-container>
                  <h5>Extension</h5>
                  <div class="detail-item">{{ user?.extension?.name ? user?.extension?.name : 'N/A' }}</div>
               </ng-container>
            </div>
         </div>
         <div ndtRightColumn>
            <div class="detail-right-column">
               <div class="user-preference-wrapper">
                  <h4 class="mb-xs">Table Row Style</h4>
                  <div class="help-text">Choose between single-color or alternating rows.</div>
                  <mat-radio-group formControlName="useAlternatingRowColors" class="row-style-options">
                     <mat-radio-button
                        color="primary"
                        [value]="false"
                        [checked]="this.form.get('useAlternatingRowColors').value !== true"
                        >Single Color</mat-radio-button
                     >
                     <mat-radio-button
                        color="primary"
                        [value]="true"
                        [checked]="this.form.get('useAlternatingRowColors').value === true"
                        >Alternating Colors</mat-radio-button
                     >
                  </mat-radio-group>
               </div>
            </div>
         </div>
      </ndt-two-column-layout>
      <ndt-form-footer (cancel)="onCancel()" [visible]="form.dirty" [callState]="callState"></ndt-form-footer>
   </form>
</lcs-loading-overlay>
<mat-menu #updateDetailsMenu="matMenu">
   <update-details
      [createUser]="user?.createUser"
      [createDate]="user?.createDate"
      [updateUser]="user?.updateUser"
      [updateDate]="user?.updateDate"
   ></update-details>
</mat-menu>
